<template>
  <div class='section-intro padding-y-sm' >
      <Loader
      :isLoading='load_garage'
      />  

      <Header
      :BackPage='false'
      :HideCart='true'
      :Title='saldoCredito'
      
      />

  <div>

    <Carrousel
    v-if='!this.load_garage'
    Title='meus carros'
    class="mt-5" 
    >
      <CardCar
      v-for="car in this.garage"  :key="car.car"
      :carName='car.car_name'
      :carBrand='car.car_brand'
      :carYear='car.ano.year'
      :carMotor='car.car_motor'
      :carImg='car.car_img'
      :carId='car.car'
      :garageID='car.id'
      />
    </Carrousel>

    <Carrousel
    v-else
    Title='meus carros'
    class="mt-5" 
    >

      <CarSkeleton
      :Loading='this.load_garage'
      />
      <CarSkeleton
      :Loading='this.load_garage'
      />

      <CarSkeleton
      :Loading='this.load_garage'
      />
      <CarSkeleton
      :Loading='this.load_garage'
      />

    </Carrousel>

<div class='btn_wrapper'>
    <div class='add_car mb-3'>

      <ButtonCallToAction
      Type='button'
      Text='CADASTRAR CARRO'
      :ButtonFunction='addNewCar'
      Icon='fas fa-car'
      />

    </div>
    <div class='add_car mb-3'>

      <ButtonCallToAction
      Type='button'
      Text='ACOMPANHAR PEDIDOS'
      :ButtonFunction='goToPedidos'
      Icon='fas fa-list'
      />

    </div>
    <div class='add_car mb-3'>
        <pwa-install 
        manifestpath='/manifest.json'
        cancelbuttontext='Cancelar'
        descriptionheader='Adicione o nossso aplicativo na sua area de trabalho'
        iosinstallinfotext='Adicione o nossso aplicativo na sua area de trabalho'
        installbuttontext='Adicionar'
        id="pwa-install"
        @click='install'
        >INSTALAR APLICATIVO </pwa-install>

    </div>
  </div>

  <Carrousel
      Title='OFERTAS'
      >

      <CarSkeleton
      :Loading='this.CardColletionLoader'
      />
      <CarSkeleton
      :Loading='this.CardColletionLoader'
      />

    
      <CardColletion
      v-for="col in this.colecoes  "  :key="col.id"
      :colecaoName='col.nome'
      :colecaoId='col.id'
      :colecaoDescricao='col.descricao'
      :colecaoImg='col.img'
      :colecaoProducts='col.products'
      :Loading='CardColletionLoader'
      
      />

    </Carrousel>
    </div>
       <p @click='logout' class="exit"> <i  class="fas fa-sign-out-alt">Sair</i> </p>
  </div>
</template>

<script>
import "@pwabuilder/pwainstall";
import ButtonCallToAction from '../../components/Button/ButtonCallToAction'
import Header from '../../components/Header/Header'
import { mapActions, mapState } from 'vuex'
import Carrousel from '../../components/Carrousel/CarrouselProduct'
import CardColletion from '../../components/Cards/CardColletion'
import CardCar from '../../components/Cards/CardCar'
import { getLocalToken} from '../../modules/auth/storage'
import CarSkeleton from '../../components/Load/CarSkeleton'
import Loader from '@/components/Load/LoadOverlay'
import {formatPrice} from '../../tools/formatPrice'

export default {
  name: 'Home',
  data() {
    return {
      CardColletionLoader: false,
         
    }
  },
  computed: {
    ...mapState({
      credit: state => state.home.credit,
      credit_data: state => state.home.credit_data,
      load_garage: state => state.home.load_garage,
      garage: state => state.home.garage,
      colecoes: state => state.home.colecoes
    }),

    creditoLocal () {
      return  localStorage.getItem('credito');
    },
    saldoCredito(){
      return 'Crédito R$ ' + this.formatN(this.credit)
    },
    userLocal (){
      return JSON.parse(localStorage.getItem('user') || "[]");
    },
    userLocalId (){
      return localStorage.getItem('id_user');
    },
    tokenLocal (){
      return getLocalToken()
    },
    localGarage (){
      return  JSON.parse(localStorage.getItem('garage') || "[]");
    },
    data_creditoLocal (){
      return  localStorage.getItem('data_atualizao_credito');
    },
  },
  methods: {
    ...mapActions('home',['ActionLoadGarage', 'ActionGetCredito','ActionSetLocalGarage','ActionGetColecoes']),
    ...mapActions('auth',['ActionSignOut']),
   
    async logout () {
      await this.ActionSignOut()
      this.$router.push({name:'login'})
    },
    async getCredito(id){
      await this.ActionGetCredito(id)
    },

    install(){
    var installComponent = document.getElementById("pwa-install");
    document.body.appendChild(installComponent);
    installComponent.getInstalledStatus();
    },
    formatN (price) {
      return formatPrice(price)
    },
    refreshGarage(){
      this.ActionLoadGarage({id:this.userLocalId});
      this.getCredito(this.userLocalId)
    },
    addNewCar(){
       this.$router.push({name:'add_car'}).catch(err => { err, this.$router.push({name:'add_car'})})
    },
     getColecao(){
      this.CardColletionLoader = true
      this.ActionGetColecoes();
      this.CardColletionLoader = false
    },
    goToPedidos(){
      this.$router.push({name:'acompanhar_pedido'})
    }


  },

     created () {
       this.ActionLoadGarage({id:this.userLocalId});
       if (this.credit && this.credit_data && this.garage ){
         console.log('Seja bem vindo a sua garagem.')
         
       }

       else {

         if (this.localGarage && this.userLocalId){
            this.ActionSetLocalGarage({garage:this.localGarage})
            this.ActionGetCredito(this.userLocalId)
         }
         
         
         
       }

       //this.ActionGetCredito(this.userLocal.id)
     //if (JSON.stringify(this.garage) === '{}' === false){
        // this.ActionLoadGarage({id:this.user.id});
        
     // }
      //else {
      //  alert(JSON.stringify(this.localGarage) === '{}')
     // }
     
    },
     mounted () {
        this.getColecao()
       if (this.$metrika) this.$metrika.reachGoal('my-goal')
   
  
    },

  components: {

    Carrousel,
    CardCar,
    CarSkeleton,
    Loader,
    CardColletion,
    Header,
    ButtonCallToAction

  },
}

//get na garagem
//se nao houver garagem exibe video
//get no saldo
//ajustar links
//se escolher carro seta carro na store

</script>

<style lang="css" >

pwa-install::part(openButton) {
    background: var(--main-white);
    border: 1px solid var(--main-red-black);
    box-sizing: border-box;
    border-radius: 8px;
    color: var(--main-red-black);
    font-size: 1.1857rem;
    font-weight: bold;
    padding: .6rem 1rem;
    width: 100%;
}

.bg{
background: rgb(146,25,20);
background: linear-gradient(180deg, rgba(146,25,20,1) 0%, rgba(146,25,20,1) 12%, rgba(255,255,255,1) 12%);
  min-height:100vh
}

.btn_wrapper{
  display:flex;
  flex-direction:column;
}

.add_car{
  width:85%;
  margin:auto;
}

.saldo{
  color:var(--main-white);
  margin-bottom: 5%;
  
}

.title_saldo{
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.2rem;
  /* identical to box height */
  font-feature-settings: 'cpsp' on;
}

.data_credito{
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 0.8rem;
  line-height: 1.2rem;
  /* identical to box height */
  font-feature-settings: 'cpsp' on;
}

.valor_saldo{
  font-family: Roboto;
  font-style: normal;
  font-weight: 900;
  font-size: 2rem;
  line-height: 2rem;
  /* identical to box height */
  font-feature-settings: 'cpsp' on;
}

.exit {
    font-size: 14px;
    line-height: 20px;
    color: var(--main-red-black);
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: center;
    cursor: pointer;
}



  @media (min-width: 800px) {


  .add_car{
  width:30rem;
  margin: auto;
}

.btn_wrapper{
  display:flex;
  flex-direction:row;
  
}

  }

</style>
